




























import api from '@/services/api';
import { Component, Vue } from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import 'bootstrap';
import bootbox from 'bootbox';
import BrowserAlert from '@/components/BrowserAlert.vue';
import Version from '@/components/Version.vue';
import {HomeRoute, ResetPasswordRoute} from '@/services/Authorize';
import _ from 'underscore';

@Component({
    components: {
        BrowserAlert,
        Version
    }
})
export default class Login extends Vue {
    public emailAddress: string = '';
    public password: string = '';

    public sendForm() {
        const data: object = {
            emailAddress: this.emailAddress,
            password: this.password
        };
        api().post('login', data)
            .then((response) => {
                if (response.data.success === true) {
                    this.changeLoginToTrue();
                    this.$store.commit('setActiveProfile', UserProfile.userProfileFromAPI(response.data.user));
                    const appEntryURL: string = this.$store.getters.getAppEntryURL;

                    switch (true) {
                        case this.$store.getters.getActiveProfile.passwordExpired:
                            return this.$router.push(ResetPasswordRoute);

                        case !appEntryURL || _.contains(['/login', '', '/'], appEntryURL):
                            return this.$router.push(HomeRoute);

                        default:
                            return this.$router.push(appEntryURL);
                    }

                } else {
                    bootbox.alert(response.data.message);
                }
            })
            .catch((response) => {
                if (response.status === 500) {
                    bootbox.alert('There was an issue logging in. Please try again.');
                } else {
                    bootbox.alert('Invalid username/password.');
                }
            });
    }

    public changeLoginToTrue(): void {
        this.$store.commit('setLoggedIn', true);
    }
}
